/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon64Regular = forwardRef('DataChartPieA1Icon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.031 6.006A1.992 1.992 0 0 0 31 8v22.634c0 1.54 1.667 2.502 3 1.732l19.602-11.317c.95-.548 1.3-1.784.711-2.756A25.5 25.5 0 0 0 33.031 6.006ZM34 28.902V9.05a22.5 22.5 0 0 1 17.192 9.926L34 28.902Z" }),
        React.createElement("path", { d: "M24.964 10.103a1.5 1.5 0 0 0-.918-2.856A26 26 0 1 0 57.519 27.02a1.5 1.5 0 0 0-2.945.575 23 23 0 1 1-29.61-17.493Z" })));
});
